import { useState, useEffect } from 'react';

import { isMobileDevice, isElemVisible } from 'lib/utils';
import usePricingStore from 'stores/pricing_store/usePricingStore';
import useProductShowStore from 'stores/product_show_store/useProductShowStore';

import ProductPricing from 'components/products/product_pricing';
import CEFQuantitySelector, {
  QuantitySelectorError,
} from 'components/product_show/add_to_basket/quantity_selector';

import AddToBasketCro from 'components/product_show/add_to_basket/add_to_basket';
import ReserveAndCollect from 'components/product_show/reserve_and_collect/reserve_and_collect';

const StickyAddToBasket = ({
  stepId,
  title,
  brand,
  stockCode,
  category,
  minOrderValue,
  maxOrderValue,
  fetchPriceUrl,
  vatExclusive,
  addToBasketUrl,
  isCollectionOnly,
  partCode,
  priceBeforeCurrentSale,
  priceBeforeCurrentSaleIncVAT,
  isOnClearance,
  isRedemptionOffer,
  disabled,
  isDeliveryOnly,
  storeStockUrl,
  isSimilarStock,
  isStoreSelected,
}) => {
  const [show, setShow] = useState(false);

  const { productPrice } = usePricingStore();
  const { quantitySelectorError } = useProductShowStore();

  useEffect(() => {
    const handleScroll = () => {
      const addToBasketBtn = document.querySelector(
        '.product-show__pricing-box .product-action-btn',
      );
      const header = document.querySelector('.cef-site-header');
      const productImage = document.querySelector(
        '.product-show__image-carousel',
      );

      if (
        (isMobileDevice() &&
          !isElemVisible(addToBasketBtn) &&
          !isElemVisible(header) &&
          // checking if page is scrolled to bottom of the page
          // to allow the user to interact with the footer
          window.innerHeight + window.scrollY >= document.body.offsetHeight ===
            false &&
          !isElemVisible(productImage)) ||
        (!isMobileDevice() &&
          !isElemVisible(addToBasketBtn) &&
          !isElemVisible(header))
      ) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!productPrice) {
    return null;
  }

  const renderQuantitySelector = () => (
    <CEFQuantitySelector
      stepId={stepId}
      minOrderValue={minOrderValue}
      maxOrderValue={maxOrderValue}
      fetchPriceUrl={fetchPriceUrl}
    />
  );

  return (
    <div
      className={`sticky-header${show ? ' sticky-header--show' : ''}${
        priceBeforeCurrentSale || isOnClearance || isRedemptionOffer
          ? ' sticky-header__price-before-current-sale'
          : ''
      }`}
      data-testid="product-actions__sticky">
      <div className="container">
        <div className="fl ai-c jc-sb">
          <div className="fl ai-c fl-grow-1 jc-sb sticky-header-content">
            <div className="product-actions fl fl-grow-1 jc-sb">
              <div className="fl jc-sb g-8">
                <ProductPricing
                  id={stepId}
                  prices={productPrice}
                  vatExclusive={vatExclusive}
                  priceBeforeCurrentSale={priceBeforeCurrentSale}
                  priceBeforeCurrentSaleIncVAT={priceBeforeCurrentSaleIncVAT}
                  isOnClearance={isOnClearance}
                  isRedemptionOffer={isRedemptionOffer}
                />
                <div
                  className="m-d-none"
                  data-testid="product-actions__sticky-quantity-selector--mobile">
                  {renderQuantitySelector()}
                </div>
              </div>
              <div className="fl m-g-12 fl-col m-fl-row">
                <div className="product-actions__quantity-selector fl fl-col-reverse l-fl-row g-12 jc-fe ai-fe l-ai-c">
                  {quantitySelectorError && (
                    <div className="mb-8 m-mb-0">
                      <QuantitySelectorError
                        quantitySelectorError={quantitySelectorError}
                      />
                    </div>
                  )}
                  <div
                    className="l-as-fs d-none m-d-block"
                    data-testid="product-actions__sticky-quantity-selector--desktop">
                    {renderQuantitySelector()}
                  </div>
                </div>
                <div
                  className="product-actions__buttons fl fl-row g-12 mt-20"
                  data-testid="product-actions__sticky-ctas">
                  <div className="fl fl-col g-16 fl-grow-1 fb-0">
                    <AddToBasketCro
                      stepId={stepId}
                      addToBasketUrl={addToBasketUrl}
                      stockCode={stockCode}
                      brand={brand}
                      title={title}
                      category={category}
                      partCode={partCode}
                      isReserveCollect={false}
                      isCollectionOnly={isCollectionOnly}
                      isSimilarStock={isSimilarStock || false}
                      showStock={false}
                      type="sticky"
                    />
                  </div>
                  <div className="fl fl-col g-16 fl-grow-1 fb-0">
                    <ReserveAndCollect
                      isDeliveryOnly={isDeliveryOnly}
                      storeStockUrl={storeStockUrl}
                      isStoreSelected={isStoreSelected}
                      stepId={stepId}
                      addToBasketUrl={addToBasketUrl}
                      title={title}
                      category={category}
                      stockCode={stockCode}
                      partCode={partCode}
                      brand={brand}
                      vatExclusive={vatExclusive}
                      disabled={disabled}
                      productPrice={productPrice}
                      showStock={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyAddToBasket;
